export enum RefreshNotificationItemAction {
    Append = 1,
    Prepend = 2,
    ClearAll = 3,
    ClearItem = 4
}
